const { stringComparator } = require('./utils/comparators');

module.exports = stringComparator(
  'suffix',
  (param, suffix) => param.endsWith(suffix)
);
